import React from "react";
import config from './../config.js';
import Loading from './../../components/loading.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

class Profile extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }
    //console.log(user);
    this.state = {
      page_title: '修改个人资料',
      page_subtitle: ' Profile',
      loading: false,
      user: user
    }
    document.title = this.state.page_title + this.state.page_subtitle;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleInputChange(event) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;

    const user = this.state.user;
    Object.assign(user, {
      [name]: value
    });
    this.setState(user);

  }


  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const me = this;
    const user = Object.assign(me.state.user, {
      type: 'profile',
      Authorization: localStorage.token
    });
    console.log(user)
    me.setState({
      loading: true
    });
    fetch(config.host + '/user/index', {
      method: 'post',
      body: JSON.stringify(user)
    })
      .then(response => response.json())
      .then(json => {
        if (json.status === 1) {
          const data = json.data;
          localStorage.user = JSON.stringify(data);
          me.setState({
            loading: false,
            user: data
          });
          me.notify('保存成功');
        } else {
          me.setState({
            loading: false
          });
          me.notify(json.message);
        }
      })
      .catch(error => {
        console.log(error);
      });
    return;
  }

  onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit();
    }
  }


  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }


  render() {
    return (
      <div>
        <Loading display={this.state.loading} classtype="" />
        <div className="container">

          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 ">
            <h3>{this.state.page_title} <small>{this.state.page_subtitle}</small></h3>
          </div>
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label>电子邮箱</label>
              <input type="email" className="form-control" placeholder="Enter email" name="email" value={this.state.user.email} required onChange={this.handleInputChange} />
            </div>
            <div className="form-group">
              <label>用户名</label>
              <input type="text" name="username" className="form-control" placeholder="Your name" value={this.state.user.username || ''} onChange={this.handleInputChange} />
            </div>

            <div className="form-group">
              <label>姓名</label>
              <input type="text" name="realname" className="form-control" placeholder="Your name" value={this.state.user.realname || ''} required onChange={this.handleInputChange} />
            </div>

            <div className="form-group">
              <label>单位</label>
              <input type="text" name="address" className="form-control" placeholder="Organization" value={this.state.user.address || ''} required onChange={this.handleInputChange} />
            </div>
            <div className="form-group">
              <label>部门</label>
              <input type="text" name="office" className="form-control" placeholder="Department" value={this.state.user.office || ''} onChange={this.handleInputChange} />
            </div>

            <div className="form-group">
              <label>职位</label>
              <input type="text" name="title" className="form-control" placeholder="Title" value={this.state.user.title || ''} onChange={this.handleInputChange} />
            </div>

            <div className="form-group">
              <label>电话</label>
              <input type="text" name="telephone" className="form-control" placeholder="Telephone" value={this.state.user.telephone || ''} onChange={this.handleInputChange} />
            </div>

            <button type="submit" className="btn btn-primary" title="Submit">保 存</button>
          </form>
        </div>
      </div>
    )
  }

}

export default Profile


// WEBPACK FOOTER //
// ./src/apps/console/user_profile.js